module.exports = __webpack_public_path__ + "img/price-banner-md.42847ca1.png";